import { FlowBlockType, FlowObsoleteBlockType } from 'flow-schema';
import { z } from 'zod';

export enum UnknownBlockType {
  /**
   * This is the only unknown block type allowed.
   * It handles cases where the API says there is a block, but the type is not known.
   * This can happen during upgrades or when the API is out of sync.
   */
  Unknown = 'Unknown',
}

export const SingletonBlockTypes = new Set<FlowBlockType>([
  FlowBlockType.Start,
  FlowBlockType.Output,
]);

/**
 * Skills cannot be picked directly as a block. They are hydrated from the skill API data when
 * picked, though an existing block can still be copied and pasted with its skill data.
 */
export const NonPickableBlockTypes = new Set<FlowBlockType>([FlowBlockType.SkillV2]);

export const AnyBlockTypeSchema = z
  .enum(FlowBlockType)
  .or(z.enum(FlowObsoleteBlockType))
  .or(z.enum(UnknownBlockType));
export type AnyBlockType = z.infer<typeof AnyBlockTypeSchema>;

export enum RunMode {
  Live = 'LIVE',
  Test = 'TEST',
}

export function StringAsNumberSchema(
  numberValidation: z.ZodType<number | undefined, number | undefined>
) {
  return z.coerce
    .string()
    .optional()
    .transform((value) => (value === '' ? undefined : value))
    .refine((value) => value === undefined || !isNaN(Number(value)), {
      message: 'Invalid number',
    })
    .transform((value) => (value === undefined ? undefined : Number(value)))
    .pipe(numberValidation) as unknown as z.ZodOptional<z.ZodType<number>>;
}
